module.exports = __webpack_public_path__ + "img/favicon-2.262f04c2.svg";